import React from 'react';

import FormTitle from 'components/atoms/Form/FormTitle';
import FormField from 'components/atoms/Form/FormField';
import FormLabel from 'components/atoms/Form/FormLabel';
import RadioSelectForm from 'components/molecules/RadioSelectForm';
import FlexBox from 'components/atoms/FlexBox';
import HourInput from 'components/atoms/Form/HourInput';

// 移動時間の扱い（C3_RESDUC-1881）。「みなさない」のときは計上先と上限を隠す（隠しても値は消さずに保存する）
const EmploymentMoveTimeSettings: React.FC<{
  formik: any
}> = ({
  formik,
}) => (
  <>
    <FormTitle
      title="移動時間の扱い"
    />
    <div>
      <FormField>
        <RadioSelectForm
          label="移動時間を勤務時間と"
          name="regardMoveTime"
          items={[
            {
              label: 'みなす',
              value: '1',
            },
            {
              label: 'みなさない',
              value: '0',
            },
          ]}
          value={String(formik.values.regardMoveTime)}
          setValue={formik.handleChange}
        />
      </FormField>

      <div style={String(formik.values.regardMoveTime) === '1' ? {} : { display: 'none' }}>
        <FormField>
          <RadioSelectForm
            label="移動時間の計上先"
            name="regardMoveTimeTarget"
            items={[
              {
                label: '移動元に計上',
                value: '0',
              },
              {
                label: '移動先に計上',
                value: '1',
              },
            ]}
            value={String(formik.values.regardMoveTimeTarget)}
            setValue={formik.handleChange}
          />
        </FormField>

        <FormField>
          <div>
            <FormLabel
              label="移動時間"
            />
            <FlexBox>
              <div style={{ width: '120px' }}>
                <HourInput
                  name="regardMoveTimeMinutes"
                  value={formik.values.regardMoveTimeMinutes}
                  label="分"
                  min={1}
                  max={999}
                  onChange={formik.handleChange}
                />
              </div>
              <div style={{ marginLeft: '10px' }}>
                以内の移動は勤務時間とみなす
              </div>
            </FlexBox>
          </div>
        </FormField>
      </div>
    </div>
  </>
);

export default EmploymentMoveTimeSettings;
